import { c as _c } from "react/compiler-runtime";
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { Typography } from '@mui/material';
import { use } from 'react';
import GlobalContext from '../Providers/GlobalContext';
const Breadcrumbs = () => {
  const $ = _c(20);
  const {
    navItems
  } = use(GlobalContext);
  const router = useRouter();
  const t0 = router.pathname;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== navItems || $[1] !== router.asPath || $[2] !== router.pathname) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const pathNames = t0.split("/").filter(_temp);
      const asPathsNames = router.asPath.split("/").filter(_temp2);
      let t6;
      if ($[9] !== navItems) {
        t6 = navItems.reduce(_temp3, {});
        $[9] = navItems;
        $[10] = t6;
      } else {
        t6 = $[10];
      }
      const breadcrumbNameMap = t6;
      if (!navItems.some(e => e.path === "/" + pathNames[0]) || !pathNames.length || pathNames[0] === "management" || pathNames[0] == "report") {
        t5 = null;
        break bb0;
      }
      const formatPathStr = _temp5;
      t4 = "presentation";
      T0 = MuiBreadcrumbs;
      t1 = "breadcrumb";
      if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = <Link href="/"><Typography>Home</Typography></Link>;
        $[11] = t2;
      } else {
        t2 = $[11];
      }
      t3 = pathNames.map((value, index) => {
        const last = index === pathNames.length - 1;
        const to = `/${asPathsNames.slice(0, index + 1).join("/")}`;
        return last ? <Typography color="black" key={to}>{breadcrumbNameMap[to] || formatPathStr(value)}</Typography> : <Link href={to} key={to}><Typography>{breadcrumbNameMap[to] || formatPathStr(value)}</Typography></Link>;
      });
    }
    $[0] = navItems;
    $[1] = router.asPath;
    $[2] = router.pathname;
    $[3] = T0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    T0 = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[12] !== T0 || $[13] !== t1 || $[14] !== t2 || $[15] !== t3) {
    t6 = <T0 aria-label={t1}>{t2}{t3}</T0>;
    $[12] = T0;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t6) {
    t7 = <div role={t4}>{t6}</div>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
export default Breadcrumbs;
function _temp(x) {
  return x;
}
function _temp2(x_0) {
  return x_0;
}
function _temp3(obj, t0) {
  const {
    path,
    title
  } = t0;
  obj[path] = title;
  return obj;
}
function _temp4(word) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}
function _temp5(str) {
  return str.split("-").map(_temp4).join(" ");
}